import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import service1 from '../../Assets/Special/Aerial.png'
import service2 from '../../Assets/Special/Climate Guard.png'
import service3 from '../../Assets/Special/wallputty.png'

const ServicesCarousel = () => {
  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 3, // Show two items at a time
    slidesToScroll: 1, // Scroll two items at a time
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const services = [
    {
      img: service1,
      title: "Aerial",
      subtitle: "Exterior Damp Proof",
      description:
        "Aerial is a damp-proof solution meant specifically for outdoor surfaces as it prevents moisture and protects surfaces from potential damages.",
      bgClass: "yellowbg",
      link: "/special-products/aerial"
    },
    {
      img: service2,
      title: "Climate Guard",
      subtitle: "Exterior Weather Guard",
      description:
        "Climate Guard is a white cement-based wall putty that protects exterior walls, promoting lasting protection  with an exceptionally finished look.",
      bgClass: "greenbg",
      link: "/special-products/climate-guard"
    },
    {
      img: service3,
      title: "Majestic",
      subtitle: "White Cement-Based Wall Putty",
      description:
        "Majestic is a top-tier wall putty in white, cement-based wall putty that guarantees smooth finishes, making it a #1 choice for all kind of builders and contractors.",
      bgClass: "bluebg",
      link: "/special-products/majestic"
    },
  ];

  return (

    <div>
      <Slider {...settings} className="services-slider">
        {services.map((service, index) => (
          <div
            className={`services-itemm ${index % 2 === 1 ? "padded-item" : ""
              }`}
            key={index}
          >
            <div className="service-cardd">
              <div className="service-card__imagee">
                <img src={service.img} alt={service.title} />
              </div>
              <div className={`services-card__contentt ${service.bgClass}`}>
                <h3>
                  {service.title} <span>{service.subtitle}</span>
                </h3>
                <p>{service.description}</p>
                <a href={service.link}><button className="cust-button">Know More</button></a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>

  );
};

export default ServicesCarousel;
